import axios from "axios";
import {AuthModel} from "../app/modules/auth";
import {LOGIN_URL, OTP_CODE_VALIDATION} from "../app/modules/auth/core/_requests";

export function login(username: string, password: string) {
    return axios.post<AuthModel>(LOGIN_URL, {
        "username": username,
        "password": password,
        "authenticationType": 1
    })
}
export function otpCodeValidation(otp: number | string, username: string, password: string) {
    return axios.post(OTP_CODE_VALIDATION, {
        "username": username,
        "password": password,
        "otp": otp,
        "authenticationType": 1
    })
}
